import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagIS(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <mask id="icon-flag-is" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#icon-flag-is)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Z"
          fill="#003897"
        />
        <path
          d="M.5 2A1.5 1.5 0 0 1 2 .5h20A1.5 1.5 0 0 1 23.5 2v20a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 22V2Z"
          stroke="#3C3C64"
          strokeOpacity=".1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.75 15.75V24h-7.5v-8.25H0v-7.5h8.25V0h7.5v8.344H24v7.406h-8.25Z"
          fill="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.75 9.75V0h4.5v9.75H24v4.5h-9.75V24h-4.5v-9.75H0v-4.5h9.75Z"
          fill="#CF142B"
        />
        <circle cx={12} cy={12} r={11.5} stroke="#3C3C60" strokeOpacity={0.1} />
      </g>
    </BaseIcon>
  );
}
